<template>
  <div class="mainbody">
    <div>
      <el-table class="tableInfotext" :data="data_list" stripe>
        <el-table-column
          prop="id"
          label="序列"
          width="auto"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="企业名称"
          width="auto"
          min-width="30%"
          style="
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: rgba(0, 0, 0, 0.65);
          "
        ></el-table-column>
        <el-table-column label="缩略图" width="auto" min-width="20%">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; height: 75px"
              :src="scope.row.thumb"
              fit="cover"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="type_cn"
          label="企业分类"
          width="auto"
          min-width="13%"
        ></el-table-column>
        <el-table-column label="提交时间" width="auto" min-width="22%">
          <template slot-scope="scope">{{
            timestampToTime(scope.row.create_time)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="operating"
          label="操作"
          width="auto"
          min-width="7%"
          align="left"
        >
          <template slot-scope="scope">
            <el-button
              class="operateText"
              size="mini"
              type="text"
              @click="toDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :key="elementui_page_key"
      class="elPagination"
      background
      layout="prev, pager, next"
      :page-size="pageMaxSize"
      :page-count="pageCount"
      :current-page="currentPage"
      @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
  },
  data() {
    return {
      urlPath: URL_PATH,
      elementui_page_key: 0,
      data_list: [], // 数据列表
      pageCount: 0, // 所有页数
      pageMaxSize: 8,
      currentPage: 1,
    };
  },
  activated() {
    this.$api
      .waitReviewShop({
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: this.pageMaxSize,
      })
      .then(({ data }) => {
        this.pageCount = data.Data.pageCount;
        this.currentPage = data.Data.currentPage;
        if (this.currentPage > this.pageCount) {
          this.currentPage = this.currentPage - 1;
          this.getWaitReviewShop();
        }
      })
      .catch(({ error }) => {});
  },
  created() {
    this.getWaitReviewShop();
  },
  methods: {
    getWaitReviewShop() {
      this.$api
        .waitReviewShop({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize,
        })
        .then(({ data }) => {
          this.pageCount = data.Data.pageCount;
          this.data_list = data.Data.model;
          console.log(this.data_list);
        })
        .catch(({ error }) => {});
    },
    //点击查看跳转至详情
    toDetail(row) {
      localStorage.setItem("id", JSON.stringify(row.shop_log_id));
      this.$router.push({
        path: "/wxapp/enterprise_review",
        query: {
          id: localStorage.getItem("id"),
          title: row.title,
        },
      });
    },
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getWaitReviewShop();
    },
    //时间戳转化为日期
    timestampToTime(time) {
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var date = new Date(time * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<style lang="less" scoped>
.tableInfotext {
  // margin-top: 20px;
}
.mainbody {
  padding: 19px 32px 20px 32px;
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}

.elPagination {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriseReviewList.vue